interface ExamTimerProps {
  secondsLeft: number;
  totalSeconds: number;
}

export default function ExamTimer({ secondsLeft, totalSeconds }: ExamTimerProps) {
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const pct = (secondsLeft / totalSeconds) * 100;

  const colorClass =
    secondsLeft <= 300
      ? 'text-red-600'
      : secondsLeft <= 600
      ? 'text-amber-600'
      : 'text-emerald-700';

  const barColor =
    secondsLeft <= 300
      ? 'bg-red-500'
      : secondsLeft <= 600
      ? 'bg-amber-500'
      : 'bg-emerald-500';

  return (
    <div className="flex flex-col items-end gap-1 min-w-[120px]">
      <div className={`text-2xl font-bold tabular-nums ${colorClass}`}>
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-1000 ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs text-gray-500 font-medium">Time Remaining</span>
    </div>
  );
}
